import {
  DirectionalHint,
  getId,
  Stack,
  Text,
  TooltipDelay,
  TooltipHost,
  mergeStyles,
} from "@fluentui/react";
import styled from "styled-components";
import { ExecutionError } from "@cayo/shared/api/types/cayo-graph";
import CopyButton from "@cayo/shared/components/buttons/CopyButton";
import { FCC } from "@cayo/shared/types/react";
import clipboardUtils from "@cayo/shared/utils/clipboard";

const rootStyle = mergeStyles({
  "::after": {
    inset: "-20px",
  },
});

const ErrorTooltip: FCC<{ errors: ExecutionError[]; id: string }> = ({ id, errors, children }) => {
  const hostId: string = getId("tooltipHost");

  return (
    <TooltipHost
      tooltipProps={{
        onRenderContent: () => {
          return (
            <Stack horizontal={true} verticalAlign={"center"}>
              <ErrorsWrapper horizontal={false} key={id}>
                {errors?.map((e, i) => (
                  <Text key={i}>{e.message}</Text>
                ))}
              </ErrorsWrapper>
              <CopyButton
                onClick={() =>
                  errors &&
                  clipboardUtils.copyArrayToClipboard(
                    errors.filter((e) => !!e).map((e) => e.message!)
                  )
                }
              />
            </Stack>
          );
        },
      }}
      delay={TooltipDelay.zero}
      id={hostId}
      directionalHint={DirectionalHint.bottomCenter}
      calloutProps={{
        styles: {
          root: rootStyle,
        },
      }}
      styles={{
        root: { display: "inline-block", cursor: "pointer", width: "100%", height: "100%" },
      }}
    >
      {children}
    </TooltipHost>
  );
};

const ErrorsWrapper = styled(Stack)`
  padding: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  hyphens: auto;
`;

export default ErrorTooltip;
